import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=7590d8a6&scoped=true&"
import script from "./AddressDetails.vue?vue&type=script&lang=ts&"
export * from "./AddressDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AddressDetails.vue?vue&type=style&index=0&id=7590d8a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590d8a6",
  null
  
)

export default component.exports